import { render, staticRenderFns } from "./scanWechat.vue?vue&type=template&id=004c3fed&"
import script from "./scanWechat.vue?vue&type=script&lang=js&"
export * from "./scanWechat.vue?vue&type=script&lang=js&"
import style0 from "./scanWechat.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports